import { Attachment, DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutCommodityImage extends Layout {
    attachmentCommodityImage: Attachment;
    sourceCommodityImage: DataSource;
}
